import { saveAs } from "file-saver";
import { actionLog, getStore } from "src/store";

export function downloadStore() {
    saveStore();
    saveActionsLog();
}

export function saveStore() {
    const store = getStore();
    const state = store.getState();

    const blob = new Blob([JSON.stringify(state, null, 2)], { type: "application/json" });
    saveAs(blob, "store.json");
}

export function saveActionsLog() {
    const log = actionLog.getLog();

    const blob = new Blob([JSON.stringify(log, null, 2)], { type: "application/json" });
    saveAs(blob, "actions.json");
}
